import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function CategoryQuick() {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <div className="mb-4 flex items-center gap-2">
        <i className="ri-apps-2-line text-lg text-accent-600"></i>
        <h2 className="font-heading text-base font-bold text-foreground-950">分类快捷入口</h2>
      </div>
      <div className="grid grid-cols-2 gap-2">
        {categories.slice(0, 8).map((c) => (
          <Link
            key={c.key}
            to={`/category?type=${encodeURIComponent(c.key)}`}
            className="group flex items-center gap-2 rounded-md border border-background-200 bg-background-100 px-2.5 py-2.5 transition-colors hover:border-primary-300 hover:bg-primary-50"
          >
            <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-background-50 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
              <i className={`${c.icon} text-lg`}></i>
            </span>
            <span className="min-w-0">
              <span className="block truncate text-sm font-medium text-foreground-900">{c.key}</span>
              <span className="block font-label text-xs text-foreground-500">{c.count} 部</span>
            </span>
          </Link>
        ))}
      </div>
      <Link
        to="/category"
        className="mt-3 flex items-center justify-center gap-1 rounded-md border border-background-200 py-2 text-sm text-foreground-700 whitespace-nowrap cursor-pointer hover:border-primary-300 hover:text-primary-600 transition-colors"
      >
        查看全部分类
        <i className="ri-arrow-right-s-line"></i>
      </Link>
    </div>
  );
}